import { createLogger } from '@owl-lib/logger';
import { deserialize, fetchWrapper } from '../fetch';
import type { Run } from './interface';
const logger = createLogger(__filename);

const runsApiClient = {
  runs: async (dossier_id: string): Promise<Run[]> => {
    const url = new URL(`/app/v1/runs/${dossier_id}`, API_BASE_URL);
    logger.trace('runsApiClient.runs()');
    return deserialize(
      await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
    );
  },
};

export default runsApiClient;
